import {KeypadViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypad';
import {consoleLogger, injectable} from '@gongxigames/framework/core';

@injectable()
export class KeypadViewMobilePortrait extends KeypadViewMobileLandscape {
    public static readonly NAME: symbol = Symbol('KeypadViewMobilePortrait');

    protected initMainSprite(): void {
        const rootName = 'bottomBar_portrait';
        const config = this._objectBuilder.getDisplayObjectConfigByName(this.getMainSpriteName(rootName));

        if (config) {
            this._mainSprite = this._objectBuilder.buildSprite(config);
            this.container.addChild(this._mainSprite);
        } else {
            consoleLogger.warn(`No Sprite - '${rootName}'. Please, check resources!`);
        }
    }
}
